import Set from "./commands/set";
import Get from "./commands/get";
import Push from "./commands/push";
import Pop from "./commands/pop";
import Equal from "./commands/equal";
import NotEqual from "./commands/notEqual";
import And from "./commands/and";
import Or from "./commands/or";
import Add from "./commands/add";
import Sub from "./commands/sub";
import Mul from "./commands/mul";
import Div from "./commands/div";
import IncrBy from "./commands/incrBy";
import DecrBy from "./commands/decrBy";
import MulBy from "./commands/mulBy";
import DivBy from "./commands/divBy";
import Conditional from "./commands/conditional";
import Action from "./commands/action";
import Query from "./commands/query";
import SAdd from "./commands/sAdd";
import SUnion from "./commands/sUnion";
import SInter from "./commands/sInter";
import SDiff from "./commands/sDiff";
import SIsEmpty from "./commands/sIsEmpty";
import SIsMember from "./commands/sIsMember";
import SMembers from "./commands/sMembers";
import SPop from "./commands/sPop";
import LessThan from "./commands/lessThan";
import GreaterThan from "./commands/greaterThan";
import Return from "./commands/return";
import Exists from "./commands/exists";

class CommandFactory {

    constructor(registry) {
        this.commands = [
            Set,
            Get,
            Push,
            Pop,
            Equal,
            NotEqual,
            And,
            Or,
            Add,
            Sub,
            Mul,
            Div,
            IncrBy,
            DecrBy,
            MulBy,
            DivBy,
            Conditional,
            Action,
            Query,
            SAdd,
            SUnion,
            SInter,
            SDiff,
            SIsEmpty,
            SIsMember,
            SMembers,
            SPop,
            LessThan,
            GreaterThan,
            Return,
            Exists
        ];

        this.registry = registry;

        this.commands = this.commands.map(className => new className(registry));
    }

    getCommandsKeys() {
        return this.commands.map(command => command.key.toUpperCase());
    }

    executeCommand(commandKey, params) {
        const command = this.commands.find(command => command.compareByKey(commandKey));
        if (command) {
            return command.execute(...params);
        }
    }

    getCommand(commandKey) {
        return this.commands.find(command => command.compareByKey(commandKey));
    }
}

export default CommandFactory;
